import styled, { css, CSSProp } from 'styled-components';
import { Button, Checkbox, colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import {
  CheckboxIconStyled,
  CheckboxOutlineBlankStyled,
} from '@insurancemenu/imenu-components-lib/dist/components/Checkbox/styles';
import { breakpointsMQ4Small } from '../constants';

interface SubscriberCardStyledProps {
  $isAddedToBatchSelection?: boolean;
  $isEditable?: boolean;
}

export const SubscriberCardStyled = styled.article<SubscriberCardStyledProps>`
  /* 110rem is the standard content width for the base layout */
  max-width: 110rem;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 3rem;
  padding: 2rem 3rem 2rem 2rem;
  border-radius: 1rem;
  background-color: ${colors.neutral.white};
  border: 0.1rem solid transparent;
  border-width: 0.4rem 0.4rem 0.4rem 1.6rem;

  ${breakpointsMQ4Small} {
    padding: 2rem 2rem 2rem 1.2rem;
  }

  ${({ $isAddedToBatchSelection }): CSSProp =>
    $isAddedToBatchSelection
      ? css`
          border: 0.1rem solid ${colors.blue[600]};
          border-width: 0.4rem 0.4rem 0.4rem 1.6rem;
        `
      : ''}

  ${({ $isEditable }): CSSProp =>
    !$isEditable
      ? css`
          padding: 2rem 3rem 4rem;
          border-width: 0;

          ${breakpointsMQ4Small} {
            padding: 2rem;
          }
        `
      : ''}
`;

export const SubscriberHeaderStyled = styled.header<{ $isIncompleteProfile: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  justify-content: space-between;
  padding-bottom: 3rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};

  ${({ $isIncompleteProfile }): CSSProp =>
    $isIncompleteProfile
      ? css`
          padding-top: 3.5rem;
        `
      : ''}

  ${breakpointsMQ4.lg.down} {
    gap: 2rem;
  }
`;

export const HeaderSectionStyled = styled.div`
  display: flex;
  gap: 5rem;
  justify-content: space-between;
  align-items: flex-start;

  ${breakpointsMQ4.md.down} {
    width: 100%;
    gap: 2rem;
    flex-wrap: wrap;
  }

  ${breakpointsMQ4Small} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SubscriberNameWrapperStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const SubscriberNameStyled = styled.div`
  display: flex;
  gap: 2rem;
`;

export const SubscriberBatchCheckboxStyled = styled(Checkbox)`
  & ${CheckboxIconStyled}, & ${CheckboxOutlineBlankStyled} {
    margin: 0;
  }
`;

export const SubscriberNameLabelStyled = styled.span`
  color: ${colors.neutral[800]};
  ${typography.bold[20]}
  /* Adjusted line height to align with the checkbox icon */
  line-height: 2.4rem;
`;

export const SubscriberActionBarStyled = styled.footer`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2rem 4rem;
  padding-top: 2rem;
  border-top: 0.1rem solid ${colors.neutral[300]};
`;

export const ActionButtonStyled = styled(Button)`
  padding: 0;
  font-weight: 700;
  letter-spacing: 0.05rem;
`;

export const RemoveSubscriberButtonStyled = styled(ActionButtonStyled)`
  margin-right: auto;
`;
